import { ReactNode } from 'react';
import { useConfiguration } from '../ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import {
  StyledTextAlignmentContainer as StyledTextAlignmentContainerImport,
  StyledTextAlignmentContainerProps,
} from './TextAlignmentContainer.styles';

type TextAlignmentContainerProps = {
  children: ReactNode;
  StyledTextAlignmentContainer?: React.ComponentType<StyledTextAlignmentContainerProps>;
};

export const TextAlignmentContainer = ({
  children,
  StyledTextAlignmentContainer = StyledTextAlignmentContainerImport,
}: TextAlignmentContainerProps) => {
  const { activeTheme } = useConfiguration();

  return (
    <StyledTextAlignmentContainer textAlignment={activeTheme.textAlignment}>
      {children}
    </StyledTextAlignmentContainer>
  );
};
